import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { FaHeartBroken } from 'react-icons/fa';

import { ErrorWrapper, H3 } from '../../../styles/styledComponents';

interface FallbackProps {
    error: Error;
    resetErrorBoundary: (...args: Array<unknown>) => void;
}

export const ErrorMessage: React.FC<FallbackProps> = ({ error }) => (
    <ErrorWrapper role="alert">
        <H3 style={{ marginTop: '1rem' }}>
            <FaHeartBroken /> Tut uns leid...
        </H3>
        <p>
            Diese Darstellung funktioniert in Ihrem Browser leider nicht. Um den Inhalt ohne Probleme ansehen zu können,
            verwenden Sie bitte einen aktuelleren Browser.
        </p>
        {/*<p>
            (Fehlercode: <pre style={{ display: 'inline' }}>{error.message}</pre>)
        </p>*/}
    </ErrorWrapper>
);

interface Props {}

export const IEErrorBoundary: React.FC<Props> = ({ children }) => {
    return <ErrorBoundary FallbackComponent={ErrorMessage}>{children}</ErrorBoundary>;
};
